export const fullPageCenter = {
  padding: "4rem 0",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
};
